/**
 * FilterSearch component.
 */
import Container from '../../atoms/container/channelFilterSearchContainer';
import Focus from '@shared/types/enums/focus';
import Icon from '../../atoms/icons/searchButton';
import Press from '@components/atoms/container/channelFilterPressContainer';
import Title from './channelFilterTitle';
import TranslationManager from '@shared/assets/locale/translationsManager';
import goToSearch from '@shared/actions/search/goToSearch';
import useKeyboard from '@shared/components/utils/hooks/useKeyboard';
import { selectFocus } from '@shared/store/slices/focus.slice';
import { useAppSelector } from '@shared/store/hooks';

/**
 * Filter search component.
 * Renders the filter search button with a search icon and a press component.
 */
export default function FilterSearch() {
  const focus = useAppSelector(selectFocus);
  const focused = focus === Focus.SEARCH_FILTER;

  useKeyboard({
    focus: Focus.SEARCH_FILTER,
    keyDownHandler: (key) => {
      switch (key) {
        case 'SELECT':
          goToSearch();
          break;
      }
    },
  });

  return (
    <>
      <Container focused={focused} onClick={goToSearch}>
        <Icon />
        <Press>{TranslationManager.get('COMPONENTS.FILTER.SEARCH')}</Press>
      </Container>
      <Title />
    </>
  );
}
